module.exports = __webpack_public_path__ + "static/media/upload-dark.a249284c.svg";